var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Prop, Emit, Model } from "vue-property-decorator";
import { Getter, State } from "vuex-class";
import UserSelect from "./user-select.vue";
import EntrustedCase from "./entrusted-case.vue";
import ChooseDistribution from "./choose-distribution.vue";
import { DISTRIBUTION_TYPE } from "~/config/enum.config";
import { CaseInfoService } from '~/services/domain-service/case-info.service';
var DistributeRule = /** @class */ (function (_super) {
    __extends(DistributeRule, _super);
    function DistributeRule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.days = 0;
        // private entrustData: any=[];
        _this.allotType = "";
        _this.deptTreeData = [];
        _this.dialog = {
            // selectUser: false,
            selectEntrusted: false,
            chooseDistribution: false
        };
        _this.patternCollection = DISTRIBUTION_TYPE;
        _this.parrentType = 0;
        _this.rules = {
            collectionDays: { required: true, message: "请输入催收天数" },
            departmentId: { required: true, message: "请选择机构" },
            strategyCaseType: { required: true, message: "请选择分案类型" },
            assignModel: { required: true, message: "请选择分配方式" },
            outsourceId: [{ required: true, message: "请选择受托方", trigger: "blur" }],
            distributeMode: { required: true, message: "请选择分案策略" },
            distributeType: { required: true, message: "请选择分配到的案件池" },
            outEndCycle: [
                { required: true, message: "请输入委外到期时间" },
                { pattern: /^[1-9][0-9]*$/, message: "时间间隔只能为大于0的正整数" }
            ]
        };
        return _this;
    }
    /**
     * 验证表单数据
     */
    DistributeRule.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var form, result, userResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form = this.$refs.form;
                        return [4 /*yield*/, form.validate().catch(function () { return false; })];
                    case 1:
                        result = _a.sent();
                        userResult = true;
                        if (this.model.assignModel === "OUTER_COLLECTING" &&
                            !this.model.entrustData.length) {
                            this.$message("请选择受托方");
                            userResult = false;
                        }
                        if (this.model.assignModel === "COLLECTOR" && !this.model.users.length) {
                            this.$message("请选择分配用户");
                            userResult = false;
                        }
                        if (this.model.assignModel === "DEPARTMENT" && !this.model.departmentId) {
                            this.$message("请选择分配机构");
                            userResult = false;
                        }
                        if (result && userResult) {
                            this.emitRuleModel(this.model);
                            return [2 /*return*/, Promise.resolve()];
                        }
                        else {
                            return [2 /*return*/, Promise.reject("distribute-rule")];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DistributeRule.prototype.emitRuleModel = function (val) { };
    Object.defineProperty(DistributeRule.prototype, "departmentIds", {
        /**
         * 选中的部门数据
         */
        get: function () {
            return this.getAllParentId(this.model.departmentId);
        },
        set: function (values) {
            var result = "";
            if (values.length)
                result = values;
            this.model.departmentId = result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DistributeRule.prototype, "strategyCaseType", {
        /**
         * 切换部门数据源
         */
        get: function () {
            this.deptTreeData = this.departmentTreeData();
            return this.model.strategyCaseType;
        },
        set: function (val) {
            this.model.strategyCaseType = val;
        },
        enumerable: false,
        configurable: true
    });
    DistributeRule.prototype.getCollectionDays = function () {
        var _this = this;
        // 按机构分配不设置催收天数
        if (this.model.assignModel !== 'COLLECTOR' && this.casePoolTypes && this.casePoolTypes[0] !== 'WAIT_DISTRIBUTION' && this.casePoolTypes[0] !== 'RECOVERED_DISTRIBUTION')
            return;
        this.CaseInfoService.getCollectionDays(this.model.distributeType).subscribe(function (data) {
            if (data) {
                _this.model.collectionDays = data;
                _this.model.limitDays = data;
            }
        });
    };
    DistributeRule.prototype.allotTypeChange = function () {
        this.allotType = this.model.assignModel;
        this.model.entrustData = [];
        this.model.users = [];
        this.departmentIds = [];
        this.getCollectionDays();
    };
    DistributeRule.prototype.successConfirm = function (val) {
        this.model.entrustData = val;
        this.model.outsourceIds = val.map(function (v) { return v.outsourceId; });
        this.dialog.selectEntrusted = false;
    };
    DistributeRule.prototype.deptConfirm = function (val) {
        this.model.departmentId = val.id;
        this.getAllParentId(this.model.departmentId);
        this.dialog.chooseDistribution = false;
    };
    DistributeRule.prototype.distributionConfirm = function (val, dept) {
        this.model.departmentId = dept.id;
        this.model.users = val.map(function (v) {
            return {
                id: v.id,
                realName: v.realName
            };
        });
        this.dialog.chooseDistribution = false;
    };
    /**
     * 重置
     */
    DistributeRule.prototype.reset = function () {
        var form = this.$refs["form"];
        form.resetFields();
    };
    /**
     * 选择受托方
     */
    DistributeRule.prototype.entrustClick = function () {
        this.dialog.selectEntrusted = true;
    };
    /**
     * 选择机构/人员
     */
    DistributeRule.prototype.chooceDepartmentClick = function () {
        this.dialog.chooseDistribution = true;
    };
    __decorate([
        Dependencies(CaseInfoService)
    ], DistributeRule.prototype, "CaseInfoService", void 0);
    __decorate([
        Getter
    ], DistributeRule.prototype, "departmentData", void 0);
    __decorate([
        Getter
    ], DistributeRule.prototype, "departmentTreeData", void 0);
    __decorate([
        Getter
    ], DistributeRule.prototype, "getAllParentId", void 0);
    __decorate([
        State
    ], DistributeRule.prototype, "outSourceList", void 0);
    __decorate([
        Model("rule-change", {
            required: true,
            type: Object
        })
    ], DistributeRule.prototype, "model", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], DistributeRule.prototype, "disabledData", void 0);
    __decorate([
        Prop({ type: Array })
    ], DistributeRule.prototype, "casePoolTypes", void 0);
    __decorate([
        Emit("rule-change")
    ], DistributeRule.prototype, "emitRuleModel", null);
    DistributeRule = __decorate([
        Component({
            components: {
                UserSelect: UserSelect,
                EntrustedCase: EntrustedCase,
                ChooseDistribution: ChooseDistribution
            }
        })
    ], DistributeRule);
    return DistributeRule;
}(Vue));
export default DistributeRule;
